"use strict";
/**
 * Necessary exports
 */
var directives_1 = require('./directives');
exports.AUTOCOMPLETE_DIRECTIVES = directives_1.AUTOCOMPLETE_DIRECTIVES;
var pipes_1 = require('./pipes');
exports.AUTOCOMPLETE_PIPES = pipes_1.AUTOCOMPLETE_PIPES;
//# sourceMappingURL=index.js.map